const ScrollDownButton = ({ onClick, className }) => {
  return (
    <div className="hidden md:block fixed left-1/2 bottom-8 z-30 -translate-x-1/2">
      <div
        onClick={onClick}
        className={`floatingAnimation backdrop-filter backdrop-blur-xl transform  bg-supportiveRed hover:bg-shadeRed text-white px-4 py-2 rounded-full transition-opacity duration-300 ${className}`}
      >
        <button className={`blur-none`}>Scroll Ke Bawah</button>
      </div>
    </div>
  );
};

export default ScrollDownButton;
